<template>
  <div class="d-flex flex-row justify-content-between align-items-center px-3 py-1">
    <div>
      <a href="https://sportips.fr" class=" text-white"><img class="logo_sportips_topbar mr-1"
          src="../../assets/sportips_logo.png" />Sportips</a>
    </div>
    <div class="d-flex flex-row justify-content-center align-items-center flex-wrap">
      <div class="font-weight-bold">{{ $store.state.event.data.nom_epreuve }}</div>
      <div class="text-orange mx-2 font-weight-bold ">|</div>
      <div style="font-size:0.8rem">{{ $store.state.event.data.date_epreuve }} - {{
        $store.state.event.data.ville_competition }}</div>
    </div>
    <div>
      <!-- <b-button size="sm" @click="sharePage" class="fb-button"><v-icon name="brands/facebook-f" /> Partager</b-button> -->
    </div>
  </div>

  <!-- <b-row>
    <b-col style="padding-top: 10px" md="2"></b-col>
    <b-col md="8">

      <p style="margin-bottom: 0">
        <v-icon style="color: #f29406" name="running" />
        <span style="font-weight: bold; font-size: 1.1em">{{ $store.state.event.data.nom_epreuve }}</span>
        <br />{{ $store.state.event.data.date_epreuve }} - {{ $store.state.event.data.ville_competition }}
      </p>
    </b-col>
    <b-col>
      <b-button size="sm" @click="sharePage" class="fb-button"><v-icon name="brands/facebook-f" /> Partager</b-button>
    </b-col>
  </b-row> -->

</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    sharePage() {
      var _this = this;
      FB.ui(
        {
          method: "share",
          image:
            "https://sportips.fr/plateformeResultats/assets/resultatsenligne.png",
          href:
            "https://sportips.fr/plateformeResultats/#/epreuve?id=" +
            _this.$store.state.event.id,
        },
        function (response) { }
      );
    },
  },
};
</script>

<style scoped>
.fb-button {
  color:#14213D !important;
  background-color: #ececec !important;
  border: none;
}

.fb-button:hover {
  background-color: white !important;
  color: #1877f2 !important;
}
.logo_sportips_topbar{
  height:25px;
  width:auto;
}
</style>
